<template>
  <Component
    :is="'b-tab'"
    :disabled="disabled"
    @click="$emit('click', [title, changedStatus])"
  >
    <template #title>
      <span> {{ title }} </span><RsBadge
        v-if="badgeNumber"
        :variant="badgeVariant"
      >
        {{
          badgeNumber
        }}
      </RsBadge>
    </template>
    <OverlayScrollbars
      v-if="scrollable"
      :style="'height: ' + scrollHeight + ';'"
    >
      <slot />
    </OverlayScrollbars>
    <slot v-else />
  </Component>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsTab',

  props: {
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    changedStatus: {
      type: Object,
      default: () => {},
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
    scrollHeight: {
      type: String,
      default: '400px',
    },
    title: String,
    content: String,
    badgeNumber: Number,
    badgeVariant: String,
  },
});
</script>
